import { render, staticRenderFns } from "./BackDetailDialog.vue?vue&type=template&id=54248cbe&scoped=true&"
import script from "./BackDetailDialog.vue?vue&type=script&lang=js&"
export * from "./BackDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54248cbe",
  null
  
)

export default component.exports